"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var utilities_1 = require("../../utilities");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var SisAccountingSettingsComponent = /** @class */ (function (_super) {
    __extends(SisAccountingSettingsComponent, _super);
    function SisAccountingSettingsComponent(communicationService, kbService) {
        var _this = _super.call(this, communicationService) || this;
        _this.kbService = kbService;
        _this.disabled = false;
        return _this;
    }
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "currencyReadOnly", {
        get: function () {
            return this._currencyReadOnly;
        },
        set: function (value) {
            this._currencyReadOnly = value;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    currencyReadOnly: this._currencyReadOnly,
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "rateDateReadOnly", {
        get: function () {
            return this._rateDateReadOnly;
        },
        set: function (value) {
            this._rateDateReadOnly = value;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    rateDateReadOnly: this._rateDateReadOnly,
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "rateReadOnly", {
        get: function () {
            return this._rateReadOnly;
        },
        set: function (value) {
            this._rateReadOnly = value;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    rateReadOnly: this._rateReadOnly,
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "rateLabel", {
        get: function () {
            return this._rateLabel;
        },
        set: function (value) {
            this._rateLabel = value;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    rateLabel: utilities_1.multilingualToString(value),
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "dateLabel", {
        get: function () {
            return this._dateLabel;
        },
        set: function (value) {
            this._dateLabel = value;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    dateLabel: utilities_1.multilingualToString(value),
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "parentField", {
        get: function () {
            return this._parentField;
        },
        set: function (value) {
            this._parentField = value;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    parentField: value,
                },
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisAccountingSettingsComponent.prototype, "state", {
        set: function (value) {
            var tooltipSettings = value['tooltipSettings'];
            var hint = value['hint'];
            var dateLabel = value['dateLabel'];
            var rateLabel = value['rateLabel'];
            var currencyReadOnly = value['currencyReadOnly'];
            var rateDateReadOnly = value['rateDateReadOnly'];
            var rateReadOnly = value['rateReadOnly'];
            var parentField = value['parentField'];
            if (tooltipSettings) {
                this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(tooltipSettings);
            }
            if (hint) {
                this._hint = utilities_1.stringToMultilingual(hint);
            }
            if (dateLabel) {
                this._dateLabel = utilities_1.stringToMultilingual(dateLabel);
            }
            if (rateLabel) {
                this._rateLabel = utilities_1.stringToMultilingual(rateLabel);
            }
            if (skynet_store_utilities_1.notNil(currencyReadOnly)) {
                this._currencyReadOnly = currencyReadOnly;
            }
            if (skynet_store_utilities_1.notNil(rateDateReadOnly)) {
                this._rateDateReadOnly = rateDateReadOnly;
            }
            if (skynet_store_utilities_1.notNil(rateReadOnly)) {
                this._rateReadOnly = rateReadOnly;
            }
            if (parentField) {
                this._parentField = parentField;
            }
        },
        enumerable: true,
        configurable: true
    });
    SisAccountingSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountingFields$ = this.kbService
            .getMetaFields(this.category)
            .pipe(operators_1.first(), operators_1.map(function (metaFields) {
            return metaFields
                .filter(function (metaField) {
                return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING;
            })
                .filter(function (metaField) {
                return metaField.getSystemName() !==
                    _this.fields.field.metaFieldId.systemName;
            });
        }), operators_1.map(function (metaFields) {
            if (metaFields.length === 0) {
                return undefined;
            }
            return metaFields;
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisAccountingSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisAccountingSettingsComponent.prototype, "fields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisAccountingSettingsComponent.prototype, "formType", void 0);
    SisAccountingSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-accounting-settings',
            template: require('./sis-accounting-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <sis-accounting-settings\n            [state]=\"%{state}\"\n            [languages]=\"%{languages}\"\n            [fields]=\"%{fields}\"\n            [currentLanguageId]=\"%{currentLanguageId}\"\n            [category]=\"%{category}\"\n            [formType]=\"%{formType}\"\n            [controlLabel]=\"%{controlLabel}\"\n        >\n        </sis-accounting-settings>\n    ",
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            idm_kb_service_client_js_1.KbService])
    ], SisAccountingSettingsComponent);
    return SisAccountingSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.SisAccountingSettingsComponent = SisAccountingSettingsComponent;
//# sourceMappingURL=sis-accounting-settings.component.js.map